// MA2's additions to GET /api/admin/connectors?shape=people, typed by the shared contract and read unknown-safe.
import type { Sources } from '@cobrain/admin-contract';
type SourcesPerson = Sources['people'][number];
function field(raw: unknown, key: string): unknown {
  return raw !== null && typeof raw === 'object' && !Array.isArray(raw) ? (raw as Record<string, unknown>)[key] : undefined;
}
export function lastReadAt(raw: unknown): SourcesPerson['lastReadAt'] {
  const value = field(raw, 'lastReadAt');
  return typeof value === 'string' && Number.isFinite(Date.parse(value)) ? value : null;
}
// Whether the server offers pause and resume (SOURCE_PAUSE): read from the answer, never guessed; absent is off.
export function pauseAvailable(raw: unknown): boolean {
  return field(raw, 'pauseAvailable') === true;
}
export function recordedCalls(raw: unknown): SourcesPerson['recordedCalls'] {
  const value = field(raw, 'recordedCalls');
  // Legacy drawing fixture uses a gendered pronoun; the brief requires neutral words.
  if (value === 'None, he said so') return 'None, they said so';
  return value === 'None, they said so' || value === 'Not asked yet' ? value : null;
}
